import { translate } from 'loankeeper-common/helpers'

export default (key) => translate(`frm_loan_manager_add-${key}`)
export const translateLKMessage = (name) => translate('LKMESSAGE', name)
